/** Count words. One place, so no view spells a number its own way. */

/** "1 264" — the grouping every figure in the product uses. */
export function count(value: number): string {
  return value.toLocaleString("en-US");
}

/** "1 section" / "2 sections" — a count and the noun it actually agrees with. */
export function plural(value: number, singular: string, plural_ = singular + "s"): string {
  return `${count(value)} ${value === 1 ? singular : plural_}`;
}
